import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import styles from '../styles/configuration.module.scss'

export default function ConfigurationsFooter({ title, items }) {
  const { t } = useTranslation('configuration');

  return (
    <div className={styles.footer}>
        <Link href='/privacy'>{t('privacy')}</Link>
        <Link href='/cookies'>{t('cookies')}</Link>
        <a href='https://support.icdc.io' rel='noopener' target='_blank'>{t('support')}</a>
    </div>
  );
};
